import MonitorWrapper from '@/components/monitor-wrapper.vue';
import { socketModsFilter } from '@/utils/modsFilter';
import { mapState, mapActions } from 'vuex';
import { expect } from '@/utils/validator';
import { closeWindowListener } from '@/utils/socket';
import { unconnectTime } from '@/utils/dict';
import { subscribe } from '@/utils/mqtt/index';

let note = '[MONITOR-MIXIN][WARN]: ';

export default {
  props: {
    eventId: String,
    deviceType: String
  },
  components: {
    MonitorWrapper
  },
  provide() {
    return {
      pageData: () => this,
      getLoading: () => this.loading
    };
  },
  data() {
    const texts = ['设备连接中, 请耐心等待', '数据加载中'];

    return {
      disableNotice: true,
      loading: {
        value: false,
        text: texts[1],
        texts
      },
      initNotice: null,
      loadingTimeoutTimer: null,
      connectionNotice: null,
      destroyed: false
    };
  },
  computed: {
    ...mapState('socket', ['deviceSNMap']),
    ...mapState('history', ['historyDetailData', 'historyDetailDatas']),
    ...mapState('mqtt', ['devicesDetail']),
    sn() {
      return this.$attrs.sn || this.$route.params.sn;
    },
    deviceStateDetails() {
      return this.deviceSNMap[this.sn];
    },
    unconnectTime() {
      const { runMode } = this.deviceStateDetails || {};
      return unconnectTime[runMode || 0];
    },
    isHisDetail() {
      // 是否为历史详情页面
      return !!this.eventId;
    }
  },
  methods: {
    ...mapActions('mqtt', ['subDeviceDetail', 'unsubDeviceDetail']),
    /** @type {{subDevice: (data:any) => void }} */
    ...mapActions('history', ['getHistoryDetailData']),
    showLoading() {
      if (this.disableNotice) return;

      this.loading.text = this.loading.texts[+this.isHisDetail];
      this.loading.value = true;
    },
    hideLoading() {
      if (this.disableNotice) return;

      if (!this.loading) return;
      this.loading.value = false;
    },
    showInitNotice() {
      if (this.disableNotice) return;

      if (!this.initNotice) {
        this.initNotice = this.$notify({
          title: this.$t('hint'),
          message: this.$t('设备初始化中提示模板'),
          customClass: 'notify-content-left',
          duration: 20000,
          type: 'warning'
        });
      }
    },
    hideInitNotice() {
      if (this.disableNotice) return;

      this.initNotice && this.initNotice.close();
      this.initNotice = null;
    },
    showTimeoutNotice() {
      if (this.disableNotice) return;

      this.loadingTimeoutTimer = setTimeout(() => {
        if (this.destroyed) return;
        this.connectionNotice = this.$notify({
          title: this.$t('hint'),
          message: this.$t('设备断联提示模板', { sn: this.sn }),
          customClass: 'notify-content-left',
          type: 'warning',
          duration: 0
        });
      }, this.unconnectTime);
    },
    hideTimeoutNotice() {
      if (this.disableNotice) return;

      clearTimeout(this.loadingTimeoutTimer);
      if (this.connectionNotice) this.connectionNotice.close();
    },
    /** 发送订阅指令 */
    sendMessage() {
      this.subDeviceDetail({ sn: this.sn });
      if (!this._stopParamSub) {
        this._stopParamSub = subscribe('{prefix}/{userId}/socket/param/');
      }
    },
    async subscribe() {
      // 历史详情页面 不订阅
      if (this.isHisDetail) return;
      this.showTimeoutNotice();
      this.sendMessage();
      let old = null;
      // 订阅当前设备详细数据
      this.sockets.subscribe('/socket/detail', res => {
        // 多设备详情时 设备sn校验
        if (!res || res.sn !== this.sn) return;
        if (old && res.beginTime - old.beginTime < 100) return;

        old = res;
        // 过滤多余模块 防止动态组件显示错误
        socketModsFilter(this.deviceType, res);
        // 调用混入的页面的 updateData函数
        expect(this.updateData, 'Function', note + 'updateData') && this.updateData(res);
        // 加载中取消加载状态
        this.hideLoading();
        this.hideTimeoutNotice();
        this.showTimeoutNotice();
      });
    },
    unsubscribe() {
      this.unsubDeviceDetail({ sn: this.sn });
      this.sockets.unsubscribe('/socket/detail');
      if (this._stopParamSub) {
        this._stopParamSub();
        this._stopParamSub = null;
      }
    },
    getHisDetail() {
      if (!this.isHisDetail) return;
      this.getHistoryDetailData(this.eventId).then(res => {
        this.hideLoading();
        expect(this.updateHisData, 'Function', note + 'updateHisData') && this.updateHisData(res);
      });
    }
  },
  created() {
    this.removeListener = closeWindowListener(() => this.unsubscribe());
    this.showLoading();
    this.subscribe();
  },
  mounted() {
    this.$nextTick(() => {
      this.getHisDetail();
    });
  },
  beforeDestroy() {
    this.destroyed = true;
    // 组件销毁前 取消订阅
    this.unsubscribe();

    this.hideLoading();
    this.removeListener();
    this.hideTimeoutNotice();
    this.hideInitNotice();
  }
};
